module.exports = __webpack_public_path__ + "media/tally3.7ae8ac87.webm";